/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import Index from './Index';
import Notification from './Notification';
import ForeignKey from './ForeignKey';
import SecurityFilter from './SecurityFilter';
import QuerySubject from './QuerySubject';
import Relationship from './Relationship';
import ParameterMap from './ParameterMap';
import DrillGroup from './DrillGroup';
import QueryValueSelector from './QueryValueSelector';
import Module from './Module';
import ValidationMessage from './ValidationMessage';
import Feedback from './Feedback';
import ItemNormalizationGroupType from './ItemNormalizationGroupType';
import TextResource from './TextResource';
import FacetType from './FacetType';
import SortListType from './SortListType';
import ItemType from './ItemType';
import DataSource from './DataSource';
import PhysicalObjectType from './PhysicalObjectType';
import BaseObjectType from './BaseObjectType';
import PropertyType from './PropertyType';
import Jdbc from './Jdbc';
import Table from './Table';
import Column from './Column';
import PrimaryKey from './PrimaryKey';
import TableItemType from './TableItemType';
import StoredProcedure from './StoredProcedure';
import ProcParameterType from './ProcParameterType';
import DbFunction from './DbFunction';
import Struct from './Struct';
import Multiset from './Multiset';
import ObjectType from './ObjectType';
import Filter from './Filter';
import ItemNormalizationType from './ItemNormalizationType';
import SqlQueryType from './SqlQueryType';
import QueryItem from './QueryItem';
import TaxonomyType from './TaxonomyType';
import SplitType from './SplitType';
import PromptInfoType from './PromptInfoType';
import CalculatedMemberType from './CalculatedMemberType';
import MemberType from './MemberType';
import Translation from './Translation';
import NamedSet from './NamedSet';
import CardinalityType from './CardinalityType';
import Calculation from './Calculation';
import WhatIfModel from './WhatIfModel';
import ItemHierarchy from './ItemHierarchy';
import LocalRefType from './LocalRefType';
import CustomSort from './CustomSort';
import ParameterValueSet from './ParameterValueSet';
import ParameterValue from './ParameterValue';
import ValueType from './ValueType';
import ParameterFault from './ParameterFault';
import ParameterCapabilitiesType from './ParameterCapabilitiesType';
import Prompt from './Prompt';
import ParameterFeedbackInfo from './ParameterFeedbackInfo';
import FolderType from './FolderType';
import Focus from './Focus';
import SplitRule from './SplitRule';
import SplitConfig from './SplitConfig';
import ProjectedItemType from './ProjectedItemType';
import FolderItemType from './FolderItemType';
import DefLinkType from './DefLinkType';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/Index (runtime) // new
//@import com/ibm/bi/platform/moser/common/notify/Notification (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ForeignKey (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SecurityFilter (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubject (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Relationship (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterMap (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/DrillGroup (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryValueSelector (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Module (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ValidationMessage (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Feedback (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationGroupType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/TextResource (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SortListType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/DataSource (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Jdbc (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Table (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Column (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PrimaryKey (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/TableItemType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/StoredProcedure (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ProcParameterType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/DbFunction (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Struct (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Multiset (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Filter (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlQueryType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryItem (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/TaxonomyType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PromptInfoType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/MemberType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Translation (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/NamedSet (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Calculation (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/WhatIfModel (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemHierarchy (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/LocalRefType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/CustomSort (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValueSet (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValue (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFault (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterCapabilitiesType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Prompt (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFeedbackInfo (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/Focus (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitRule (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitConfig (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/ProjectedItemType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderItemType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/DefLinkType (runtime) // new

/**
 * This object contains factory methods for each  Java content interface and Java element interface  generated in the com.ibm.bi.platform.moser.common.generated.metadata package.  <p>An ObjectFactory allows you to programatically  construct new instances of the Java representation  for XML content. The Java representation of XML  content can consist of schema derived interfaces  and classes representing the binding of schema  type definitions, element declarations and model  groups.  Factory methods for each of these are  provided in this class.
 */
export default class ObjectFactory extends BaseMoserObject{

	_listeners = null;



	/**
	 * Creates a new instance of <code>Index</code> object and notifies all registered listeners with a create event.
	 * @return {Index} an object of type <code>Index</code>
	 */
	createIndex() {
		var result = new Index();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ForeignKey</code> object and notifies all registered listeners with a create event.
	 * @return {ForeignKey} an object of type <code>ForeignKey</code>
	 */
	createForeignKey() {
		var result = new ForeignKey();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SecurityFilter</code> object and notifies all registered listeners with a create event.
	 * @return {SecurityFilter} an object of type <code>SecurityFilter</code>
	 */
	createSecurityFilter() {
		var result = new SecurityFilter();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>QuerySubject</code> object and notifies all registered listeners with a create event.
	 * @return {QuerySubject} an object of type <code>QuerySubject</code>
	 */
	createQuerySubject() {
		var result = new QuerySubject();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Relationship</code> object and notifies all registered listeners with a create event.
	 * @return {Relationship} an object of type <code>Relationship</code>
	 */
	createRelationship() {
		var result = new Relationship();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ParameterMap</code> object and notifies all registered listeners with a create event.
	 * @return {ParameterMap} an object of type <code>ParameterMap</code>
	 */
	createParameterMap() {
		var result = new ParameterMap();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>DrillGroup</code> object and notifies all registered listeners with a create event.
	 * @return {DrillGroup} an object of type <code>DrillGroup</code>
	 */
	createDrillGroup() {
		var result = new DrillGroup();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>QueryValueSelector</code> object and notifies all registered listeners with a create event.
	 * @return {QueryValueSelector} an object of type <code>QueryValueSelector</code>
	 */
	createQueryValueSelector() {
		var result = new QueryValueSelector();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Module</code> object and notifies all registered listeners with a create event.
	 * @return {Module} an object of type <code>Module</code>
	 */
	createModule() {
		var result = new Module();
		result.setObjectFactory(this);
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ValidationMessage</code> object and notifies all registered listeners with a create event.
	 * @return {ValidationMessage} an object of type <code>ValidationMessage</code>
	 */
	createValidationMessage() {
		var result = new ValidationMessage();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Feedback</code> object and notifies all registered listeners with a create event.
	 * @return {Feedback} an object of type <code>Feedback</code>
	 */
	createFeedback() {
		var result = new Feedback();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ItemNormalizationGroupType</code> object and notifies all registered listeners with a create event.
	 * @return {ItemNormalizationGroupType} an object of type <code>ItemNormalizationGroupType</code>
	 */
	createItemNormalizationGroupType() {
		var result = new ItemNormalizationGroupType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>TextResource</code> object and notifies all registered listeners with a create event.
	 * @return {TextResource} an object of type <code>TextResource</code>
	 */
	createTextResource() {
		var result = new TextResource();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>UseSpec</code> object and notifies all registered listeners with a create event.
	 * @return {UseSpec} an object of type <code>UseSpec</code>
	 */
	createModuleUseSpec() {
		var result = new Module.UseSpec();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>FacetType</code> object and notifies all registered listeners with a create event.
	 * @return {FacetType} an object of type <code>FacetType</code>
	 */
	createFacetType() {
		var result = new FacetType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SortListType</code> object and notifies all registered listeners with a create event.
	 * @return {SortListType} an object of type <code>SortListType</code>
	 */
	createSortListType() {
		var result = new SortListType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ItemType</code> object and notifies all registered listeners with a create event.
	 * @return {ItemType} an object of type <code>ItemType</code>
	 */
	createItemType() {
		var result = new ItemType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>DataSource</code> object and notifies all registered listeners with a create event.
	 * @return {DataSource} an object of type <code>DataSource</code>
	 */
	createDataSource() {
		var result = new DataSource();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>PhysicalObjectType</code> object and notifies all registered listeners with a create event.
	 * @return {PhysicalObjectType} an object of type <code>PhysicalObjectType</code>
	 */
	createPhysicalObjectType() {
		var result = new PhysicalObjectType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>BaseObjectType</code> object and notifies all registered listeners with a create event.
	 * @return {BaseObjectType} an object of type <code>BaseObjectType</code>
	 */
	createBaseObjectType() {
		var result = new BaseObjectType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>PropertyType</code> object and notifies all registered listeners with a create event.
	 * @return {PropertyType} an object of type <code>PropertyType</code>
	 */
	createPropertyType() {
		var result = new PropertyType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Jdbc</code> object and notifies all registered listeners with a create event.
	 * @return {Jdbc} an object of type <code>Jdbc</code>
	 */
	createJdbc() {
		var result = new Jdbc();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Table</code> object and notifies all registered listeners with a create event.
	 * @return {Table} an object of type <code>Table</code>
	 */
	createTable() {
		var result = new Table();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Column</code> object and notifies all registered listeners with a create event.
	 * @return {Column} an object of type <code>Column</code>
	 */
	createColumn() {
		var result = new Column();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>IndexedColumn</code> object and notifies all registered listeners with a create event.
	 * @return {IndexedColumn} an object of type <code>IndexedColumn</code>
	 */
	createIndexIndexedColumn() {
		var result = new Index.IndexedColumn();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>PrimaryKey</code> object and notifies all registered listeners with a create event.
	 * @return {PrimaryKey} an object of type <code>PrimaryKey</code>
	 */
	createPrimaryKey() {
		var result = new PrimaryKey();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>FkColumn</code> object and notifies all registered listeners with a create event.
	 * @return {FkColumn} an object of type <code>FkColumn</code>
	 */
	createForeignKeyFkColumn() {
		var result = new ForeignKey.FkColumn();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>TableItemType</code> object and notifies all registered listeners with a create event.
	 * @return {TableItemType} an object of type <code>TableItemType</code>
	 */
	createTableItemType() {
		var result = new TableItemType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>StoredProcedure</code> object and notifies all registered listeners with a create event.
	 * @return {StoredProcedure} an object of type <code>StoredProcedure</code>
	 */
	createStoredProcedure() {
		var result = new StoredProcedure();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ProcParameterType</code> object and notifies all registered listeners with a create event.
	 * @return {ProcParameterType} an object of type <code>ProcParameterType</code>
	 */
	createProcParameterType() {
		var result = new ProcParameterType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>DbFunction</code> object and notifies all registered listeners with a create event.
	 * @return {DbFunction} an object of type <code>DbFunction</code>
	 */
	createDbFunction() {
		var result = new DbFunction();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Struct</code> object and notifies all registered listeners with a create event.
	 * @return {Struct} an object of type <code>Struct</code>
	 */
	createStruct() {
		var result = new Struct();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Multiset</code> object and notifies all registered listeners with a create event.
	 * @return {Multiset} an object of type <code>Multiset</code>
	 */
	createMultiset() {
		var result = new Multiset();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ObjectType</code> object and notifies all registered listeners with a create event.
	 * @return {ObjectType} an object of type <code>ObjectType</code>
	 */
	createObjectType() {
		var result = new ObjectType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Filter</code> object and notifies all registered listeners with a create event.
	 * @return {Filter} an object of type <code>Filter</code>
	 */
	createFilter() {
		var result = new Filter();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ItemNormalizationType</code> object and notifies all registered listeners with a create event.
	 * @return {ItemNormalizationType} an object of type <code>ItemNormalizationType</code>
	 */
	createItemNormalizationType() {
		var result = new ItemNormalizationType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SecurityObject</code> object and notifies all registered listeners with a create event.
	 * @return {SecurityObject} an object of type <code>SecurityObject</code>
	 */
	createSecurityFilterSecurityObject() {
		var result = new SecurityFilter.SecurityObject();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SqlQueryType</code> object and notifies all registered listeners with a create event.
	 * @return {SqlQueryType} an object of type <code>SqlQueryType</code>
	 */
	createSqlQueryType() {
		var result = new SqlQueryType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>QueryOperation</code> object and notifies all registered listeners with a create event.
	 * @return {QueryOperation} an object of type <code>QueryOperation</code>
	 */
	createQuerySubjectQueryOperation() {
		var result = new QuerySubject.QueryOperation();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>JoinOperation</code> object and notifies all registered listeners with a create event.
	 * @return {JoinOperation} an object of type <code>JoinOperation</code>
	 */
	createQuerySubjectJoinOperation() {
		var result = new QuerySubject.JoinOperation();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>TimeGrain</code> object and notifies all registered listeners with a create event.
	 * @return {TimeGrain} an object of type <code>TimeGrain</code>
	 */
	createQuerySubjectTimeGrain() {
		var result = new QuerySubject.TimeGrain();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>TimeAnchor</code> object and notifies all registered listeners with a create event.
	 * @return {TimeAnchor} an object of type <code>TimeAnchor</code>
	 */
	createQuerySubjectTimeAnchor() {
		var result = new QuerySubject.TimeAnchor();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ActiveTimeGrain</code> object and notifies all registered listeners with a create event.
	 * @return {ActiveTimeGrain} an object of type <code>ActiveTimeGrain</code>
	 */
	createQuerySubjectActiveTimeGrain() {
		var result = new QuerySubject.ActiveTimeGrain();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ColumnDependency</code> object and notifies all registered listeners with a create event.
	 * @return {ColumnDependency} an object of type <code>ColumnDependency</code>
	 */
	createQuerySubjectColumnDependency() {
		var result = new QuerySubject.ColumnDependency();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>QueryItem</code> object and notifies all registered listeners with a create event.
	 * @return {QueryItem} an object of type <code>QueryItem</code>
	 */
	createQueryItem() {
		var result = new QueryItem();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>TaxonomyType</code> object and notifies all registered listeners with a create event.
	 * @return {TaxonomyType} an object of type <code>TaxonomyType</code>
	 */
	createTaxonomyType() {
		var result = new TaxonomyType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SplitType</code> object and notifies all registered listeners with a create event.
	 * @return {SplitType} an object of type <code>SplitType</code>
	 */
	createSplitType() {
		var result = new SplitType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>PromptInfoType</code> object and notifies all registered listeners with a create event.
	 * @return {PromptInfoType} an object of type <code>PromptInfoType</code>
	 */
	createPromptInfoType() {
		var result = new PromptInfoType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>CalculatedMemberType</code> object and notifies all registered listeners with a create event.
	 * @return {CalculatedMemberType} an object of type <code>CalculatedMemberType</code>
	 */
	createCalculatedMemberType() {
		var result = new CalculatedMemberType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>MemberType</code> object and notifies all registered listeners with a create event.
	 * @return {MemberType} an object of type <code>MemberType</code>
	 */
	createMemberType() {
		var result = new MemberType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Translation</code> object and notifies all registered listeners with a create event.
	 * @return {Translation} an object of type <code>Translation</code>
	 */
	createTranslation() {
		var result = new Translation();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>NamedSet</code> object and notifies all registered listeners with a create event.
	 * @return {NamedSet} an object of type <code>NamedSet</code>
	 */
	createNamedSet() {
		var result = new NamedSet();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>CardinalityType</code> object and notifies all registered listeners with a create event.
	 * @return {CardinalityType} an object of type <code>CardinalityType</code>
	 */
	createCardinalityType() {
		var result = new CardinalityType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Link</code> object and notifies all registered listeners with a create event.
	 * @return {Link} an object of type <code>Link</code>
	 */
	createRelationshipLink() {
		var result = new Relationship.Link();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ParameterMapEntry</code> object and notifies all registered listeners with a create event.
	 * @return {ParameterMapEntry} an object of type <code>ParameterMapEntry</code>
	 */
	createParameterMapParameterMapEntry() {
		var result = new ParameterMap.ParameterMapEntry();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>QueryItemMap</code> object and notifies all registered listeners with a create event.
	 * @return {QueryItemMap} an object of type <code>QueryItemMap</code>
	 */
	createParameterMapQueryItemMap() {
		var result = new ParameterMap.QueryItemMap();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Calculation</code> object and notifies all registered listeners with a create event.
	 * @return {Calculation} an object of type <code>Calculation</code>
	 */
	createCalculation() {
		var result = new Calculation();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Segment</code> object and notifies all registered listeners with a create event.
	 * @return {Segment} an object of type <code>Segment</code>
	 */
	createDrillGroupSegment() {
		var result = new DrillGroup.Segment();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>WhatIfModel</code> object and notifies all registered listeners with a create event.
	 * @return {WhatIfModel} an object of type <code>WhatIfModel</code>
	 */
	createWhatIfModel() {
		var result = new WhatIfModel();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ItemHierarchy</code> object and notifies all registered listeners with a create event.
	 * @return {ItemHierarchy} an object of type <code>ItemHierarchy</code>
	 */
	createItemHierarchy() {
		var result = new ItemHierarchy();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>LocalRefType</code> object and notifies all registered listeners with a create event.
	 * @return {LocalRefType} an object of type <code>LocalRefType</code>
	 */
	createLocalRefType() {
		var result = new LocalRefType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>CustomSort</code> object and notifies all registered listeners with a create event.
	 * @return {CustomSort} an object of type <code>CustomSort</code>
	 */
	createCustomSort() {
		var result = new CustomSort();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ParameterValueSet</code> object and notifies all registered listeners with a create event.
	 * @return {ParameterValueSet} an object of type <code>ParameterValueSet</code>
	 */
	createParameterValueSet() {
		var result = new ParameterValueSet();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ParameterValue</code> object and notifies all registered listeners with a create event.
	 * @return {ParameterValue} an object of type <code>ParameterValue</code>
	 */
	createParameterValue() {
		var result = new ParameterValue();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ValueType</code> object and notifies all registered listeners with a create event.
	 * @return {ValueType} an object of type <code>ValueType</code>
	 */
	createValueType() {
		var result = new ValueType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ParameterFault</code> object and notifies all registered listeners with a create event.
	 * @return {ParameterFault} an object of type <code>ParameterFault</code>
	 */
	createParameterFault() {
		var result = new ParameterFault();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ParameterCapabilitiesType</code> object and notifies all registered listeners with a create event.
	 * @return {ParameterCapabilitiesType} an object of type <code>ParameterCapabilitiesType</code>
	 */
	createParameterCapabilitiesType() {
		var result = new ParameterCapabilitiesType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Prompt</code> object and notifies all registered listeners with a create event.
	 * @return {Prompt} an object of type <code>Prompt</code>
	 */
	createPrompt() {
		var result = new Prompt();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SortExpression</code> object and notifies all registered listeners with a create event.
	 * @return {SortExpression} an object of type <code>SortExpression</code>
	 */
	createQueryValueSelectorSortExpression() {
		var result = new QueryValueSelector.SortExpression();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ParameterFeedbackInfo</code> object and notifies all registered listeners with a create event.
	 * @return {ParameterFeedbackInfo} an object of type <code>ParameterFeedbackInfo</code>
	 */
	createParameterFeedbackInfo() {
		var result = new ParameterFeedbackInfo();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>FolderType</code> object and notifies all registered listeners with a create event.
	 * @return {FolderType} an object of type <code>FolderType</code>
	 */
	createFolderType() {
		var result = new FolderType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Focus</code> object and notifies all registered listeners with a create event.
	 * @return {Focus} an object of type <code>Focus</code>
	 */
	createFocus() {
		var result = new Focus();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ErrorData</code> object and notifies all registered listeners with a create event.
	 * @return {ErrorData} an object of type <code>ErrorData</code>
	 */
	createValidationMessageErrorData() {
		var result = new ValidationMessage.ErrorData();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Data</code> object and notifies all registered listeners with a create event.
	 * @return {Data} an object of type <code>Data</code>
	 */
	createFeedbackData() {
		var result = new Feedback.Data();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Msg</code> object and notifies all registered listeners with a create event.
	 * @return {Msg} an object of type <code>Msg</code>
	 */
	createFeedbackMsg() {
		var result = new Feedback.Msg();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SplitRule</code> object and notifies all registered listeners with a create event.
	 * @return {SplitRule} an object of type <code>SplitRule</code>
	 */
	createSplitRule() {
		var result = new SplitRule();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SplitConfig</code> object and notifies all registered listeners with a create event.
	 * @return {SplitConfig} an object of type <code>SplitConfig</code>
	 */
	createSplitConfig() {
		var result = new SplitConfig();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>ProjectedItemType</code> object and notifies all registered listeners with a create event.
	 * @return {ProjectedItemType} an object of type <code>ProjectedItemType</code>
	 */
	createProjectedItemType() {
		var result = new ProjectedItemType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>FolderItemType</code> object and notifies all registered listeners with a create event.
	 * @return {FolderItemType} an object of type <code>FolderItemType</code>
	 */
	createFolderItemType() {
		var result = new FolderItemType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>DefLinkType</code> object and notifies all registered listeners with a create event.
	 * @return {DefLinkType} an object of type <code>DefLinkType</code>
	 */
	createDefLinkType() {
		var result = new DefLinkType();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Key</code> object and notifies all registered listeners with a create event.
	 * @return {Key} an object of type <code>Key</code>
	 */
	createItemNormalizationGroupTypeKey() {
		var result = new ItemNormalizationGroupType.Key();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Attribute</code> object and notifies all registered listeners with a create event.
	 * @return {Attribute} an object of type <code>Attribute</code>
	 */
	createItemNormalizationGroupTypeAttribute() {
		var result = new ItemNormalizationGroupType.Attribute();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Item</code> object and notifies all registered listeners with a create event.
	 * @return {Item} an object of type <code>Item</code>
	 */
	createTextResourceItem() {
		var result = new TextResource.Item();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Ancestors</code> object and notifies all registered listeners with a create event.
	 * @return {Ancestors} an object of type <code>Ancestors</code>
	 */
	createModuleUseSpecAncestors() {
		var result = new Module.UseSpec.Ancestors();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>DataSourceOverride</code> object and notifies all registered listeners with a create event.
	 * @return {DataSourceOverride} an object of type <code>DataSourceOverride</code>
	 */
	createModuleUseSpecDataSourceOverride() {
		var result = new Module.UseSpec.DataSourceOverride();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Context</code> object and notifies all registered listeners with a create event.
	 * @return {Context} an object of type <code>Context</code>
	 */
	createFacetTypeContext() {
		var result = new FacetType.Context();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>SortItem</code> object and notifies all registered listeners with a create event.
	 * @return {SortItem} an object of type <code>SortItem</code>
	 */
	createSortListTypeSortItem() {
		var result = new SortListType.SortItem();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>Folder</code> object and notifies all registered listeners with a create event.
	 * @return {Folder} an object of type <code>Folder</code>
	 */
	createItemTypeFolder() {
		var result = new ItemType.Folder();
		var notification = new Notification(4, result, 0, null, null, -1);
		this.notify(notification);
		return result;
	}

	/**
	 * Creates a new instance of <code>MoserObject</code> object and notifies all registered listeners with a create event.
	 * @param {String} moserObjectType moser object type to create
	 * @return {MoserObject} an object of type <code>MoserObject</code>
	 */
	createMoserObjectByObjectType(moserObjectType) {
		if (moserObjectType == null) {
			return null;
		}
		switch (moserObjectType) {
		case "Index":
			return this.createIndex();
		case "ForeignKey":
			return this.createForeignKey();
		case "SecurityFilter":
			return this.createSecurityFilter();
		case "QuerySubject":
			return this.createQuerySubject();
		case "Relationship":
			return this.createRelationship();
		case "ParameterMap":
			return this.createParameterMap();
		case "DrillGroup":
			return this.createDrillGroup();
		case "QueryValueSelector":
			return this.createQueryValueSelector();
		case "Module":
			return this.createModule();
		case "ValidationMessage":
			return this.createValidationMessage();
		case "Feedback":
			return this.createFeedback();
		case "ItemNormalizationGroupType":
			return this.createItemNormalizationGroupType();
		case "TextResource":
			return this.createTextResource();
		case "UseSpec":
			return this.createModuleUseSpec();
		case "FacetType":
			return this.createFacetType();
		case "SortListType":
			return this.createSortListType();
		case "ItemType":
			return this.createItemType();
		case "DataSource":
			return this.createDataSource();
		case "PhysicalObjectType":
			return this.createPhysicalObjectType();
		case "BaseObjectType":
			return this.createBaseObjectType();
		case "PropertyType":
			return this.createPropertyType();
		case "Jdbc":
			return this.createJdbc();
		case "Table":
			return this.createTable();
		case "Column":
			return this.createColumn();
		case "IndexedColumn":
			return this.createIndexIndexedColumn();
		case "PrimaryKey":
			return this.createPrimaryKey();
		case "FkColumn":
			return this.createForeignKeyFkColumn();
		case "TableItemType":
			return this.createTableItemType();
		case "StoredProcedure":
			return this.createStoredProcedure();
		case "ProcParameterType":
			return this.createProcParameterType();
		case "DbFunction":
			return this.createDbFunction();
		case "Struct":
			return this.createStruct();
		case "Multiset":
			return this.createMultiset();
		case "ObjectType":
			return this.createObjectType();
		case "Filter":
			return this.createFilter();
		case "ItemNormalizationType":
			return this.createItemNormalizationType();
		case "SecurityObject":
			return this.createSecurityFilterSecurityObject();
		case "SqlQueryType":
			return this.createSqlQueryType();
		case "QueryOperation":
			return this.createQuerySubjectQueryOperation();
		case "JoinOperation":
			return this.createQuerySubjectJoinOperation();
		case "TimeGrain":
			return this.createQuerySubjectTimeGrain();
		case "TimeAnchor":
			return this.createQuerySubjectTimeAnchor();
		case "ActiveTimeGrain":
			return this.createQuerySubjectActiveTimeGrain();
		case "ColumnDependency":
			return this.createQuerySubjectColumnDependency();
		case "QueryItem":
			return this.createQueryItem();
		case "TaxonomyType":
			return this.createTaxonomyType();
		case "SplitType":
			return this.createSplitType();
		case "PromptInfoType":
			return this.createPromptInfoType();
		case "CalculatedMemberType":
			return this.createCalculatedMemberType();
		case "MemberType":
			return this.createMemberType();
		case "Translation":
			return this.createTranslation();
		case "NamedSet":
			return this.createNamedSet();
		case "CardinalityType":
			return this.createCardinalityType();
		case "Link":
			return this.createRelationshipLink();
		case "ParameterMapEntry":
			return this.createParameterMapParameterMapEntry();
		case "QueryItemMap":
			return this.createParameterMapQueryItemMap();
		case "Calculation":
			return this.createCalculation();
		case "Segment":
			return this.createDrillGroupSegment();
		case "WhatIfModel":
			return this.createWhatIfModel();
		case "ItemHierarchy":
			return this.createItemHierarchy();
		case "LocalRefType":
			return this.createLocalRefType();
		case "CustomSort":
			return this.createCustomSort();
		case "ParameterValueSet":
			return this.createParameterValueSet();
		case "ParameterValue":
			return this.createParameterValue();
		case "ValueType":
			return this.createValueType();
		case "ParameterFault":
			return this.createParameterFault();
		case "ParameterCapabilitiesType":
			return this.createParameterCapabilitiesType();
		case "Prompt":
			return this.createPrompt();
		case "SortExpression":
			return this.createQueryValueSelectorSortExpression();
		case "ParameterFeedbackInfo":
			return this.createParameterFeedbackInfo();
		case "FolderType":
			return this.createFolderType();
		case "Focus":
			return this.createFocus();
		case "ErrorData":
			return this.createValidationMessageErrorData();
		case "Data":
			return this.createFeedbackData();
		case "Msg":
			return this.createFeedbackMsg();
		case "SplitRule":
			return this.createSplitRule();
		case "SplitConfig":
			return this.createSplitConfig();
		case "ProjectedItemType":
			return this.createProjectedItemType();
		case "FolderItemType":
			return this.createFolderItemType();
		case "DefLinkType":
			return this.createDefLinkType();
		case "Key":
			return this.createItemNormalizationGroupTypeKey();
		case "Attribute":
			return this.createItemNormalizationGroupTypeAttribute();
		case "Item":
			return this.createTextResourceItem();
		case "Ancestors":
			return this.createModuleUseSpecAncestors();
		case "DataSourceOverride":
			return this.createModuleUseSpecDataSourceOverride();
		case "Context":
			return this.createFacetTypeContext();
		case "SortItem":
			return this.createSortListTypeSortItem();
		case "Folder":
			return this.createItemTypeFolder();
		default:
			return null;
		}
	}

	/**
	 * Adds a listener to the factory for envent notifications.
	 * @param {INotificationListener} listener listener to be added.
	 */
	addListener(listener) {
		if (!this._listeners) {
			this._listeners = [];
		}
		this._listeners.push(listener);
	}

	/**
	 * Removes a listener from the factory.
	 * @param {INotificationListener} listener listener to be removed.
	 */
	removeListener(listener) {
		if (this._listeners) {
			for (var i = 0; (i < this._listeners.length); ++i) {
				if (this._listeners[i] === listener) {
					this._listeners.splice(i, 1);
					break;
				}
			}
		}
	}

	/**
	 * Fires the notifications to the listeners.
	 * @param {Notification} notification notifications to be fired.
	 */
	notify(notification) {
		if (this._listeners) {
			for (var __i_enFor0 = 0, __exp_enFor0 = this._listeners, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var listener = __exp_enFor0[__i_enFor0];
				listener(notification);
			}
		}
	}

	/**
	 * Create a new ObjectFactory that can be used to create new instances of schema derived classes for package: com.ibm.bi.platform.moser.common.generated.metadata
	 */
	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/ObjectFactory.js